import React from "react";

const TechnologyStack = () => {
  return (
    <div className="automobile-technology-wrapper">
      <div className="section-title">
        <h1 className="title">Technology Stack</h1>
      </div>

      <div className="technology-details-container mb-5">
        <div className="technology-details">
          <div className="technology-card-wrapper">
            <div className="card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#f3792c"
                  d="M11 7.83A3 3 0 0 1 9 5a3 3 0 0 1 3-3a3 3 0 0 1 3 3c0 1.31-.84 2.42-2 2.83v2.81a3.66 3.66 0 0 0-2 0zm7.3 13.27a2.99 2.99 0 0 1-1.46-3.14l-2.44-1.41c.48-.46.84-1.05 1-1.73l2.44 1.41c.94-.81 2.32-.97 3.45-.32c1.44.83 1.93 2.66 1.1 4.09a2.987 2.987 0 0 1-4.09 1.1M2.7 15.9c1.13-.65 2.51-.48 3.45.32l2.45-1.41c.16.69.51 1.27 1 1.73l-2.45 1.41c.23 1.22-.32 2.5-1.45 3.15c-1.44.83-3.27.34-4.1-1.1a3 3 0 0 1 1.1-4.1M14 14a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2a2 2 0 0 1 2 2m3 0l-.03.57l-1.47-.86c-.1-1.07-.67-2-1.5-2.59V9.41c1.77.78 3 2.54 3 4.59m-2.03 4.03c-.83.61-1.86.97-2.97.97s-2.14-.36-2.97-1l1.47-.83c.46.21.97.33 1.5.33s1.03-.12 1.5-.33zm-7.94-3.47L7 14c0-2.05 1.23-3.81 3-4.58v1.71c-.83.58-1.4 1.51-1.5 2.57z"
                />
              </svg>
              <h4 className="card-title">
                Real-time data analytics for supply chain visibility
              </h4>
            </div>
          </div>

          <div className="technology-card-wrapper">
            <div className="card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 512 512"
              >
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="32"
                  d="M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"
                />
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="32"
                  d="M344 336H179.31a8 8 0 0 0-5.65 2.34l-26.83 26.83a4 4 0 0 1-5.66 0l-26.83-26.83a8 8 0 0 0-5.65-2.34H56a24 24 0 0 1-24-24h0a24 24 0 0 1 24-24h288a24 24 0 0 1 24 24h0a24 24 0 0 1-24 24ZM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"
                />
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="32"
                  d="M256 480h139.31a32 32 0 0 0 31.91-29.61L463 112"
                />
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="32"
                  d="m368 112l16-64l47-16"
                />
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-miterlimit="10"
                  stroke-width="32"
                  d="M224 112h256"
                />
              </svg>
              <h4 className="card-title">
                Mobile-friendly for on-the-go management
              </h4>
            </div>
          </div>

          <div className="technology-card-wrapper">
            <div className="card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 256 256"
              >
                <path
                  fill="#f3792c"
                  d="M230.17 13.71a12 12 0 0 0-11.82-.3L101 76H32a20 20 0 0 0-20 20v104a20 20 0 0 0 20 20h88a20 20 0 0 0 20-20v-32a11.9 11.9 0 0 0-.51-3.45L118.32 94L212 44v112h-12v-4a12 12 0 0 0-24 0v8a20 20 0 0 0 20 20h20a20 20 0 0 0 20-20V24a12 12 0 0 0-5.83-10.29M95.07 100l16.8 56H76v-56ZM52 100v56H36v-56Zm-16 96v-16h80v16Z"
                />
              </svg>
              <h4 className="card-title">
                Integrates with leading ERP and CRM platforms
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyStack;
